import { ChangeDetectionStrategy, Component } from '@angular/core';
import {
  CabinetProfileViewComponent,
  CabinetStaffProxyToolbarComponent,
} from '@nebalkon-workspace/cabinet-client';

@Component({
  selector: 'lib-staff-user-detail',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CabinetStaffProxyToolbarComponent, CabinetProfileViewComponent],
  template: `
    <lib-cabinet-staff-proxy-toolbar />
    <lib-cabinet-profile-view />
  `,
  styles: `
    :host {
      display: flex;
      flex-direction: column;
      width: 100%;
    }
  `,
})
export class StaffUserDetailComponent {}
